import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { scrollToCheckout } from '../utils/scroll';
export function Closing() {
  return <section className="bg-gradient-to-b from-ink to-wine px-6 py-24" data-id="element-20" data-mp="3t2lxbo0zt3sn">
      <Reveal data-id="element-21" data-mp="3f94b1vgx9cyx">
        <h2 className="text-center font-serif text-[38px] font-bold leading-[1.1] text-white" data-id="element-22" data-mp="3f79xj27zcn4v">
          Deja de esperar que esto se resuelva solo.
        </h2>
        <p className="mt-6 text-center text-[17px] leading-relaxed text-muted" data-id="element-23" data-mp="35af2itax14vc">
          Si lo que has hecho hasta ahora funcionara, ya lo tendrías.
        </p>
        <div className="mt-14 border-t border-gold/60 pt-8" data-id="element-24" data-mp="2was1i8m3m12t">
          <p className="font-serif text-lg italic leading-relaxed text-white" data-id="element-25" data-mp="2wcbftto7221y">
            “Soy Beatriz Espina, una mujer que te ayudará a despertar, a usar la mente y el corazón para encontrar tu
            amor propio y lograr que el amor te encuentre.”
          </p>
          <p className="mt-5 font-serif text-lg font-bold text-gold" data-id="element-26" data-mp="yjpadie5znw6">— MSc Beatriz Espina</p>
        </div>
        <div className="mt-12" data-id="element-27" data-mp="3r0o01mp5ev2g">
          <CtaButton label="Entrar a Elegida — $97 USD" onClick={scrollToCheckout} data-id="element-28" data-mp="3qzme2n6lgo5y" />
        </div>
      </Reveal>
    </section>;
}